import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import "lite-youtube-embed";
import "lite-youtube-embed/src/lite-yt-embed.css";
import { updateLazy } from "../../components/_helpers";

import Swiper, { Navigation, Pagination, Thumbs } from "swiper";

export default class Gallery {
  secondary: Swiper | null = null;
  primary: Swiper | null = null;

  public init = async () => {
    this.initThubms();
    this.initPrimary();
    this.initVariablesMove();

    window.addEventListener("product_hot_reload", () => {
      this.secondary?.destroy();
      this.primary?.destroy();

      setTimeout(() => {
        this.initThubms();
        this.initPrimary();
        this.initVariablesMove();

        updateLazy();
      }, 0);
    });
  };

  initThubms = () => {
    const thumbnailSlider = document.getElementById("thumbnail_slider");
    if (thumbnailSlider) {
      this.secondary = new Swiper(thumbnailSlider, {
        modules: [Navigation],
        spaceBetween: 16,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,

        navigation: {
          nextEl: ".thumbnails-next",
          prevEl: ".thumbnails-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 5,
          },
          1199: {
            slidesPerView: 3,
          },
          1366: {
            slidesPerView: 4,
          },
          1540: {
            slidesPerView: 5,
          },
        },
      });
    }
  };

  initPrimary = () => {
    const args = {
      modules: [Thumbs, Pagination],
      speed: 400,
      spaceBetween: 100,
      pagination: {
        el: ".swiper-pagination",
      },
      on: {
        slideChange: (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const image = activeSlide.querySelector("img");
          image && this.handleVariantChange(image);

          const prevSlide = swiper.slides[swiper.previousIndex],
            prevVideo = prevSlide.querySelector("video"),
            prevYouTube = prevSlide.querySelector("lite-youtube");

          prevVideo && prevVideo.pause();

          if (prevYouTube) {
            const iframe = prevYouTube.querySelector("iframe");
            iframe?.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
          }
        },
      },
    };

    if (this.secondary) {
      args["thumbs"] = {
        swiper: this.secondary,
      };
    }

    this.primary = new Swiper("#main_slider", args);
  };

  handleVariantChange = (image: HTMLImageElement) => {
    const attributes = image.getAttribute("data-attributes");
    if (!attributes) return;

    const values = JSON.parse(attributes);

    for (const key in values) {
      const select = document.querySelector(`[data-attribute_name="${key}"]`);
      if (select) {
        select.querySelector(`option[value="${values[key]}"]`)?.setAttribute("selected", "selected");
      }
    }
  };

  initVariablesMove = () => {
    const galleryHasVariables = document.querySelector(".sizename-product_gallery_cover[data-variation]");
    const variationInput = document.querySelector("input.variation_id") as HTMLInputElement;
    if (galleryHasVariables !== null && variationInput !== null) {
      jQuery("input.variation_id").change(() => {
        const val = jQuery("input.variation_id").val();
        if (val === "") return;
        const variableImage = document.querySelector(`.sizename-product_gallery_cover[data-variation="${jQuery("input.variation_id").val()}"]`);
        const slideId = Number(variableImage?.getAttribute("data-image"));
        this.primary?.slideTo(slideId);
      });
    }
  };
}
